// src/App.jsx
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import AppRouter from "./App.router";
import CityOnboardingGate from "./components/CityOnboardingGate/CityOnboardingGate";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { CitiesProvider } from "./context/CitiesContext";
import { CityPickerProvider } from "./context/CityPickerContext";
import { AuthProvider } from "./context/AuthContext";
import { ContactedProjectsProvider } from "./context/ContactedProjectsContext";
import { LoginModalProvider } from "./context/LoginModalContext";
import { ThankYouModalProvider } from "./context/ThankYouModalContext";
import { CompleteProfileModalProvider } from "./context/CompleteProfileModalContext";
import { WishlistToastProvider } from "./context/WishlistToastContext";
import { WishlistProvider } from "./hooks/useWishlist";
import { BreadcrumbProvider } from "./context/BreadcrumbContext";
import { SeoProvider } from "./context/SeoContext";
import { ThemeProvider } from "./context/ThemeContext";
import { BrandingProvider } from "./context/BrandingContext";
import { AiAssistantProvider } from "./context/AiAssistantContext";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <BrandingProvider>
            <CitiesProvider>
              <CityPickerProvider>
                <CityOnboardingGate />
                <AuthProvider>
                  <ContactedProjectsProvider>
                  <ThankYouModalProvider>
                  <AiAssistantProvider>
                    <LoginModalProvider>
                      <CompleteProfileModalProvider>
                        <WishlistToastProvider>
                          <WishlistProvider>
                            <BreadcrumbProvider>
                              <SeoProvider>
                                <ScrollToTop />
                                <AppRouter />
                              </SeoProvider>
                            </BreadcrumbProvider>
                          </WishlistProvider>
                        </WishlistToastProvider>
                      </CompleteProfileModalProvider>
                    </LoginModalProvider>
                  </AiAssistantProvider>
                  </ThankYouModalProvider>
                  </ContactedProjectsProvider>
                </AuthProvider>
              </CityPickerProvider>
            </CitiesProvider>
          </BrandingProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
